import React from "react";


const languageMap = ["US", "PL", "FR", "UK", "PT", "RU", "DE", "IT", "TR"];

const Container = ({ children }) => {
  return (
    <div className="">
     
      {children}
    </div>
  );
};

export default Container;
